import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=1c458142&scoped=true&"
import script from "./Sorter.vue?vue&type=script&lang=ts&"
export * from "./Sorter.vue?vue&type=script&lang=ts&"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=1c458142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c458142",
  null
  
)

export default component.exports